import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  Input,
  NgZone,
  Optional,
  PLATFORM_ID,
  Renderer2,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DEFAULT_FOCUSABLE_SELECTOR, findNearestFocusable } from 'app/shared/utils/focusHelper';

@Directive({
  selector: '[appFocusNearest]',
})
export class FocusNearestDirective implements AfterViewInit {
  /**
   * CSS selector used to find focusable elements.
   * You can override it when you apply the directive: <div appFocusNearest [focusSelector]="...">
   */
  @Input('focusSelector') focusSelector: string = DEFAULT_FOCUSABLE_SELECTOR;

  /**
   * Delay in milliseconds before attempting focus (useful when component is rendered inside animations or modals).
   */
  @Input('focusDelay') focusDelay = 0;

  constructor(
    private host: ElementRef<HTMLElement>,
    private ngZone: NgZone,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit(): void {
    // Don't attempt focus on server
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // schedule the search after the view settles; allow optional delay
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        try {
          const target = findNearestFocusable(this.host.nativeElement, this.focusSelector);
          if (target) {
            // Focus the element. Use preventScroll where available.
            try {
              (target as HTMLElement).focus({ preventScroll: true });
            } catch {
              // fallback for older browsers
              (target as HTMLElement).focus();
            }
          }
        } catch {
          // swallow: focus attempts shouldn't crash the app
        }
      }, this.focusDelay);
    });
  }
}